(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AllInclusivePropertySheetBuildPreview',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$(document).bind('drag-drop-files-changed', function attachmentsChanged(e, data) {
			$('#allinclusivepropertysheetbuildpreview-attachments_changed').val(1);
		});

		Adzuki.Editor('#allinclusivepropertysheetbuildpreview-notes');
		Adzuki.Editor('#allinclusivepropertysheetbuildpreview-message');

		// only visible when editing an existing sheet
		if ($('#allinclusivepropertysheetbuildpreview-client_message').length) {
			Adzuki.Editor('#allinclusivepropertysheetbuildpreview-client_message');
		}
		$('#allinclusivepropertysheetbuildpreview-check_in_date').on('dp.change', function dateChange(e) {
			var $checkout_date;

			if (e.date === false) {
				return;
			}

			$checkout_date = $('#allinclusivepropertysheetbuildpreview-check_out_date');
			$checkout_date.data('DateTimePicker').date(e.date.add(1, 'days'));
		});
	};
}(jQuery, window.Adzuki || {}));
